"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEventManager = void 0;
const rxjs_1 = require("rxjs");
class CSEventManager {
    constructor() {
        this.event = new rxjs_1.BehaviorSubject('');
    }
    profileStatus(value) {
        this.event.next(value);
    }
}
exports.CSEventManager = CSEventManager;
//# sourceMappingURL=event-manager.service.js.map